module.exports = __webpack_public_path__ + "static/media/S (93).e9973a7c.jpg";